import { useMemo } from 'react';
import { useMMKVNumber } from 'react-native-mmkv';

export default function useSizes(
  withFontScale: number[],
  withoutFontScale: number[],
) {
  const [s] = useMMKVNumber('overrideScale');
  const [f] = useMMKVNumber('fontSize');

  const scale = s ?? 1;
  const fontScale = f ?? 1;

  const without = useMemo(
    () => withoutFontScale.map(e => e / scale),
    [withoutFontScale, scale],
  );
  const _with = useMemo(
    () => withFontScale.map(e => (e / scale) * fontScale),
    [withFontScale, scale, fontScale],
  );

  const result: [number[], number[], number, number] = useMemo(
    () => [_with, without, scale, fontScale],
    [_with, without, scale, fontScale],
  );
  return result;
}
